module.exports = __webpack_public_path__ + "img/parent.5c822dab.jpg";